
const Axios = require('axios');
const { brower } = require('@/common/wxJs/wx-util');
function doLogin() {
    if (process.env.NODE_ENV !== "development" || (brower.version.weixin)) {
        return false
    }
    Axios({
        method: 'get',
        url: '/shopapi/api/devtest/login',
        params: getUA()
    }).then(function (res) {
        if (!res.data) {
            return false
        }
        let data = res.data;
        // data = data.replace("https://ryapi.xinhuamm.net" ,"https://ryapi.platform.xinhuaapp.com")
        window.open(data)
    }).catch((err) => {

    })
}
function getUA() {
    var u = navigator.userAgent;
    var userId = getUserAgentKey('userId/');
    var appId = getUserAgentKey('appId/');
    var currentSiteId = getUserAgentKey('currentSiteId/');
    //获取用户标识
    function getUserAgentKey(key) {
        var arr = u.substring(u.search(key)).split(' ') || [],
            id = '';
        for (var i = 0, len = arr.length; i < len; i++) {
            if (arr[i].indexOf(key) > -1) {
                id = arr[i].replace(key, '');
                break;
            }
        }
        return id;
    }
    return {
        userId: userId,
        // appId: appId,
        siteId: currentSiteId,
        runType: 'test',
        application: 'lottery',
        ryredirect: location.href
    };
}
module.exports = {
    doLogin: doLogin
}


// WEBPACK FOOTER //
// ./src/test.js